import React from "react";
import { Button } from "@design-system/Button/Button";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useIsTableReadonly } from "@hooks/useIsReadonlyOrLocked";
import styles from "../DirectoryTable.module.scss";

interface Props {
    count: number;
    isDisabled: boolean;
    table: { options: { meta?: object } };
    onClick: (event: React.MouseEvent) => void;
}

export const CounterpartyCountCell: React.FC<Props> = ({
    count,
    isDisabled,
    table,
    onClick,
}) => {
    const isReadonly = useIsTableReadonly(table);

    if (isReadonly) {
        return <ViewTableCell>{count}</ViewTableCell>;
    }

    return (
        <ViewTableCell>
            <Button
                variant="secondary"
                size="sm"
                className={styles.countButton}
                onClick={onClick}
                disabled={isDisabled}
            >
                {count}
            </Button>
        </ViewTableCell>
    );
};
